import React from 'react';
import { KitchenPrinterList } from './KitchenPrinterList';

const kitchenPrinterRoutes = [
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/outlet-setting/:outletID/kitchen-printer`,
		},
		component: <KitchenPrinterList />,
	},
];

export default kitchenPrinterRoutes;
